import React, { useEffect, useState } from "react";
import "./ContainsTokenDropdown.css";

const ContainsTokenDropdown = ({
  label,
  onApply,
  onClose,
  style,
  initialEmailVal,
}) => {
  //States
  const [value, setValue] = useState("");

  //Handlers
  const cancelHandler = () => {
    setValue("");
    onClose();
  };

  const applyHandler = () => {
    onApply(value);
    onClose();
  };

  //Effects
  useEffect(() => {
    setValue(initialEmailVal || "");
  }, [initialEmailVal]);

  return (
    <div style={style} className="ct-dropdown-container">
      <h6 className="ct-heading">
        {label} <span>contains</span>
      </h6>
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="ct-dropdown-input"
      />
      <div className="ct-dropdown-actions">
        <button className="cancel-btn" onClick={cancelHandler}>
          Cancel
        </button>
        <button
          disabled={value?.trim() === ""}
          className={`apply-btn ${value?.trim() === "" ? "disabled" : ""}`}
          onClick={applyHandler}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default ContainsTokenDropdown;
